import React from 'react'
import { useTranslation } from "react-i18next";
import "./style.css"

const AboutUs = () => {
  const { t } = useTranslation();
  return (
    <section id="AboutUs">
      <div className="wallpaper">

      </div>
      <div className="aboutBlock">
            <div className="info">
              <h1> {t("aboutInfo.title")} </h1>
              <p>
                    {t("aboutInfo.description")}
              </p>
            </div>
            <div className='aboutContent'>
                <div>
                    <p>
                        {t("aboutInfo.main")}
                    </p>
                </div>
                <div className="imageHolder">
                    
                </div>
            </div>
      </div>
    </section>
  )
}
export default AboutUs;